export default {
  reports: [],
  pagination: {},
  report: {}
}
